




























import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class Privacy extends Vue {

  created(){
      
  }

  // privacyProtocol: any = {
  //   title: "個人資料(私隱)政策/私隱政策聲明",
  //   contents: [
  //     {
  //       content:
  //         "1. 高盈國際(香港)金融集團有限公司，簡稱「高盈金融」，將按照《個人資料(私隱)條例》(《香港法例》第 486 章) （「私隱條例」）的規定，竭力保存客戶的個人資料，確保客戶的個人資料妥善保存，不被非法使用、遺失、披露及損失。"
  //     },
  //     {
  //       content:
  //         "2. 無論任何時候，客戶均需向高盈金融提供個人資料（「資料」），以作個人資料(私隱)條例下之用途。 有關客戶的資料(或其他資料)可能用於以下用途：",
  //       childContent: [
  //         "- 向客戶提供之服務及設施之日常運作；",
  //         "- 進行信貸審查及協助其他機構進行信貸審查；",
  //         "- 設計供客戶使用之金融服務或相關產品；",
  //         "- 向客戶推廣金融服務及相關產品；",
  //         "- 釐定拖欠客戶或客戶拖欠之債務金額；",
  //         "- 向客戶收取拖欠之金額，利息及手續費；",
  //         "- 根據任何法例或規例之規定符合作出披露之要求；",
  //         "- 與客戶及帳戶有關之任何用途。"
  //       ]
  //     },
  //     {
  //       content:
  //         "3. 高盈金融持有之客戶有關的資料(及其他資料)將會保密，但高盈金融可向以下人士披露所有資料 (及其他資料)，而客戶同意披露所有資料(及其他資料)亦是高盈金融客戶提供服務、產品及資料之條件：",
  //       childContent: [
  //         "- 任何向高盈金融提供有關其業務運作之行政、信貸資料、債務追討、電訊、電腦、繳款或其他服務之高級職員、僱員、代理、承包商或第三者；",
  //         "- 客戶已有或擬與之進行交易之任何金融機構；",
  //         "- 監管當局及其他有關政府機構；",
  //         "- 高盈金融的專業顧問(包括但不限於其核數師及法律顧問)；",
  //         "- 任何有責任為高盈金融保密之其他人士，包括高盈金融集團以內承諾保持此等資料機密之公司;",
  //         "- 高盈金融內公司之間對客戶之資料使用，須依據嚴格之內部安全標準、保密政策及適用法律;",
  //         "- 高盈金融須約束僱員完全遵守該等標準、政策及法律；",
  //         "- 除為了進行業務、遵守適用法律、保護免受欺詐或作出我們認為可能符合客戶利益之產品及服務優惠外， 高盈金融不會將有關客戶的資料分發予其他公司。高盈金融亦可依據適用法律向監管當局及執法人員提供資料；",
  //         "- 若客戶同意(包括表示不反對)，高盈金融將會使用及/或轉送客戶的資料給任何高盈金融作直接促銷之用。高盈金融不時持有的客戶的姓名、聯絡詳情、財務背景及統計資料可由高盈金融用於直接促銷下列產品和服務：(i) 金融服務和產品；(ii) 相關優惠計劃；(iii) 金融與投資建議 ；或(iv) 高盈金融就前述產品或服務之業務推廣和宣傳活動。"
  //       ]
  //     },
  //     {
  //       content:
  //         "4. 高盈金融對向客户提供之任何訊息及資料絕不涉及或承擔任何義務、職責或責任。"
  //     },
  //     {
  //       content:
  //         "5. 由於高盈金融需要通知客戶有關服務及/或監管要求的重要資訊，高盈金融會使用客戶個人資料以電郵、郵寄或短訊發送重要資訊予客戶。"
  //     },
  //     {
  //       content:
  //         "6. 依據私隱條例之條款，高盈金融有權就處理任何資料索取查閱之申請收取合理費用。"
  //     },
  //     {
  //       content:
  //         "7. 如果客戶的資料被不小心地、没有留意地或疏忽地被寄出、洩漏、發出或傳出給第三者，在私隱條例允許的範圍內，客戶不能要求高盈金融對上述行為負責及不能向高盈金融採取任何的索償、訴訟或法律行動去追討客戶的任何損失或損害。"
  //     },
  //     {
  //       content:
  //         "8. 本聲明並未載有任何內容限制客戶根據私隱條例可享有的任何權利。"
  //     }
  //   ]
  // };
}
